<script setup>
import { toggleFavoriteVerse } from '@/libs/favorites';
import { stateManager } from '@/stateManager';
import { useRoute, useRouter } from 'vue-router';

const router = useRouter();
const route = useRoute();
const emit = defineEmits(['updateFavoriteStatus', 'openFullScreen']);
const props = defineProps({
    canOpenView: { type: Boolean },
    fullScreen: { type: Boolean },
    verse: { type: Number, required: true },
    favoriteVerses: { type: Array, required: true }, // [1, 4, 6] ...
});
const psalm_number = Number(route.params.number);

function openVerse() {
  router.push(`/s/${psalm_number}/v/${props.verse+1}`)
}

function addVerseToFav() {
  updateFavoritesCountValue();
  toggleFavoriteVerse(psalm_number, props.verse+1);
  emit('updateFavoriteStatus');
}

function updateFavoritesCountValue() {
    const entry = `${psalm_number}-${props.verse+1}`;
    const verses = (localStorage.getItem('favoriteVerses') || '')
        .split(',')
        .filter(Boolean); // remove 'falsy' (null, undefined, ...) el.
    const isAddOperation = !verses.includes(entry);
    isAddOperation ? stateManager.total_favorite_count++ : stateManager.total_favorite_count--;
}
</script>

<template>
    <div class="actionItems">
        <span v-if="fullScreen" title="apri a piena pagina" class="verse-link" v-on:click="emit('openFullScreen')">
            <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#111111"><path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h560v-280h80v280q0 33-23.5 56.5T760-120H200Zm188-212-56-56 372-372H560v-80h280v280h-80v-144L388-332Z"/></svg>
        </span> 

        <span v-if="canOpenView" title="apri versetto" class="verse-link" v-on:click="openVerse()">
            <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#111111"><path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h560v-280h80v280q0 33-23.5 56.5T760-120H200Zm188-212-56-56 372-372H560v-80h280v280h-80v-144L388-332Z"/></svg>
        </span> 
    
        <span title="salva versetto" class="verse-link save" v-on:click="addVerseToFav()">       
            <svg v-if="favoriteVerses.includes(verse+1)" xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="#EA3323"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="#111"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"/></svg>
        </span>
    </div>
</template>